import * as vviewer from 'vviewer-v4';

let vv;

function start() {
  vv?.$destroy();
  vv = vviewer.start(
    vviewer.options({
      environmentTextureOptions: [
        // https://polyhaven.com/a/christmas_photo_studio_05
        {
          label: 'room',
          value: String(new URL('./christmas_photo_studio_05_1k_256.env', import.meta.url)),
        },
        // https://polyhaven.com/a/noon_grass
        {
          label: 'sunny',
          value: String(new URL('./noon_grass_1k_256.env', import.meta.url)),
        },
        // https://polyhaven.com/a/dikhololo_night
        {
          label: 'night',
          value: String(new URL('./dikhololo_night_1k_256.env', import.meta.url)),
        },
        // https://polyhaven.com/a/urban_street_03
        {
          label: 'street',
          value: String(new URL('./urban_street_03_1k_256.env', import.meta.url)),
        },
        // https://polyhaven.com/a/studio_small_08
        {
          label: 'studio',
          value: String(new URL('./studio_small_08_1k_256.env', import.meta.url)),
        },
      ],
      highDefinition: true,
      groundMirrorEnabled: true,
      skyboxEnabled: true,
    })
  );
}

start();
window.addEventListener('hashchange', start);
